import * as Components from '../../../../Components';
import { TypeOfAuth } from '../menu-auth-type';
import ScheduleIcon from '@material-ui/icons/Schedule';
import HealingIcon from '@material-ui/icons/Healing';

export default [
    // {
    //     icon: <ScheduleIcon />,
    //     label: 'Dashboard',
    //     path: '/',
    //     exact: true,
    //     component: () => {
    //         return <Components.TechnicianSchedule status="5" />;
    //     },
    //     authType: TypeOfAuth.Auth
    // },
    {
        label: 'Repair Required',
        path: '/inspection_repair_required',
        exact: true,
        component: () => {
            return <Components.VehicleInspection status={1} />;
        },
        authType: TypeOfAuth.Auth
    },
    {
        label: 'Awating Sign Off',
        path: '/Inspection_Awaiting_Sign_Off',
        exact: true,
        component: () => {
            return <Components.VehicleInspection status={3} />;
        },
        authType: TypeOfAuth.Auth
    },
    {
        label: 'Shipments',
        path: '/ProductShipments',
        exact: true,
        hidden: true,
        component: Components.ShipmentsGrid,
        authType: TypeOfAuth.Auth
    },
    {
        label: 'Inspection Completed',
        path: '/inspection_completed',
        exact: true,
        component: () => {
            return <Components.VehicleInspection status={5} />;
        },
        authType: TypeOfAuth.Auth
    },
    {
        label: 'Repair In Progress',
        path: '/in_progress',
        exact: true,
        component: () => {
            return <Components.VehicleInspection status={2} />;
        },
        authType: TypeOfAuth.Auth
    },
    {
        label: 'Holiday',
        path: '/holiday',
        exact: true,
        component: () => {
            return <Components.HolidayShiftCalender />;
        },
        authType: TypeOfAuth.Both
    },
    {
        label: 'Signed Off',
        path: '/signed_off',
        exact: true,
        component: () => {
            return <Components.VehicleInspection status={4} />;
        },
        authType: TypeOfAuth.Auth
    }
];
